import { HttpClient } from '@angular/common/http';
import { type EnvironmentProviders } from '@angular/core';
import { type OpenIdConfiguration, provideAuth, StsConfigHttpLoader, StsConfigLoader, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { map } from 'rxjs';

const configId = 'infoShow20260522T15:20:00';

export const stsHttpAuthLoaderFactory = (httpClient: HttpClient): StsConfigHttpLoader => {
  const config$ = httpClient.get<{ issuer: string }>(`/api/v1/config`).pipe(
    map((configSettings: { issuer: string }) => {
      return buildOpenIdConfiguration(configSettings);
    })
  );
  return new StsConfigHttpLoader(config$);
};

export function buildOpenIdConfiguration(configSettings: { issuer: string }): OpenIdConfiguration {
  const origin = globalThis.location.origin;
  const config: OpenIdConfiguration = {
    authority: configSettings.issuer,
    configId,
    clientId: 'infoshow_client',
    scope: 'openid profile roles email offline_access info_show_api',
    responseType: 'code',
    redirectUrl: `${origin}/callback`,
    postLoginRoute: '/ring',
    postLogoutRedirectUri: `${origin}/logged-out`,
    unauthorizedRoute: '/unauthorized',
    autoUserInfo: true,
    secureRoutes: [`/api/v1/admin`, `/api/v1/press`],
    silentRenew: true,
    useRefreshToken: true,
    ignoreNonceAfterRefresh: true, //lasciare disabilitato!!!!
    renewTimeBeforeTokenExpiresInSeconds: 600 //dieci minuti di lasco
  };

  return config;
}

export function provideOidcAuth(): EnvironmentProviders {
  return provideAuth(
    {
      loader: {
        provide: StsConfigLoader,
        useFactory: stsHttpAuthLoaderFactory,
        deps: [HttpClient]
      }
    },
    withAppInitializerAuthCheck()
  );
}

export { authInterceptor } from 'angular-auth-oidc-client';
